import { UITooltip } from '../ui/component/tooltip';
import { $el } from '../ui/elements';
import { $path } from '../ui/path';
import { UISVGContent, $svg, UISVG } from '../ui/svg';
import { UIPoint, UISize, UIRect } from '../ui/types';
import { CHChartElement } from './chart';
import { CHPieChartOptions } from './pie';

export interface SankeyItem {
    key: string;
    count: number;

    next: { [key: string]: number };
}

export interface SankeyStep {
    total: number;
    others: string[];
    items: SankeyItem[];
}


export class CHSankey implements UISVGContent, CHChartElement {
    root: SVGGElement;

    _steps: SankeyStep[];
    _options: CHPieChartOptions;

    _center?: UIPoint;
    _radius?: number;

    _gradient?: string;

    constructor(steps: SankeyStep[], options: CHPieChartOptions = {}) {
        this.root = $svg.G('ch-sankey');

        this._steps = steps;
        this._options = options;
    }

    layout(size: UISize) {
        this._radius = Math.min(size[0], size[1]) / 2 * 0.8;
        this._center = [size[0] / 2, size[1] / 2];
    }

    render(svg: UISVG, overlay: HTMLElement) {
        const root = this.root;
        const steps = this._steps;

        let x = 50;

        const all_rects: { [key: string]: UIRect }[] = [];

        let max_y = 0;

        for(const step of steps) {
            const step_rects: { [key: string]: UIRect } = {};

            const total = step.total;

            let y = 50;

            for(const item of step.items) {
                const h = item.count / total * 600;
                step_rects[item.key] = [x, y, x + 36, y + h];

                root.appendChild($svg.ROUNDEDRECT(x, y, 36, h, 3, 3, item.key == '-' ? 'm-drop' : item.key == 'others' ? 'm-others' : ''));
                y += h + 24;
            }

            x += 220;
            all_rects.push(step_rects);

            y += 26;
            if(y > max_y)
                max_y = y;
        }

        for(let i = 0; i < steps.length - 1; i++) {
            const step = steps[i];
            const next_step = steps[i + 1];
            const next_dy: { [key: string]: number } = {};
            for(const item of step.items) {
                const rect = all_rects[i][item.key];
                const next = item.next;
                let y = rect[1];
                for(const n_item of next_step.items) {
                    const c = next[n_item.key];
                    if(!c) continue;
                    const n_dy = next_dy[n_item.key] || 0;
                    const n_rect = all_rects[i + 1][n_item.key];
                    const h = c / item.count * (rect[3] - rect[1]);
                    const n_h = c / n_item.count * (n_rect[3] - n_rect[1]);
                    $path.start();
                    $path.moveTo(rect[2] - 3, y);
                    $path.lineTo(rect[2] - 3, y + h);
                    $path.bezierTo(rect[2] + 30, y + h, n_rect[0] - 30, n_rect[1] + n_dy + n_h, n_rect[0] + 3, n_rect[1] + n_dy + n_h)
                    $path.lineTo(n_rect[0] + 3, n_rect[1] + n_dy);
                    $path.bezierTo(n_rect[0] - 30, n_rect[1] + n_dy, rect[2] + 30, y, rect[2] - 3, y);
                    root.prepend($path.toElem(n_item.key == '-' ? 'm-drop' : ''));
                    y += h;
                    next_dy[n_item.key] = n_dy + n_h;
                }
            }
        }

        for(let i = 0; i < steps.length; i++) {
            const step = steps[i];
            for(const item of step.items) {
                const rect = all_rects[i][item.key];
                const text = $el.DIV('ch-sankey-overlay', [
                    item.key != '-' && $el.I(item.key),
                    $el.SPAN('r-numbers', item.count + ' (' + (item.count / step.total * 100).toFixed(1) + '%)')
                ]);
                text.style.left = (rect[2] + 10) + 'px';
                text.style.top = ((rect[1] + rect[3]) / 2) + 'px';
                overlay.ui_add(text);
            }
        }

        // if(!this._gradient)
        //     this._gradient = svg.linearGradient('#244442', '#6cccc6');

        // const data = this._data;
        // const radius = this._radius!;
        // const center = this._center!;

        // const options = this._options;

        // const total = options.total || data.reduce((a,d) => a+d.y, 0);

        // const r2 = radius * 0.8;
        // const r1 = (options.hole || 0) * r2
        // const r3 = radius * 0.9;
        // const r4 = radius * 0.85;
        // const r5 = radius * 0.6;

        // if(options.hole_color) {
        //     $path.start();
        //     $path.arc(center[0], center[1], r1 + 1, 0, 2*Math.PI, false);
        //     const hole = $path.toElem();
        //     root.appendChild(hole);
        // }

        // $path.start();
        // $path.arc(center[0], center[1], r1, 0, 2*Math.PI, false);
        // $path.arc(center[0], center[1], r2, 2*Math.PI, 0, true);
        // $path.close();
        // const back = $path.toElem();
        // back.style.fill = '#eee';
        // root.appendChild(back);

        // if(total <= 0) return;
        // const angle_factor = 2*Math.PI / total;
        // const angle = -Math.PI/2;

        // // const nice_colors = ['#c4f080','#3cb29a','#266d98','#422b72','#2D4059','#EA5455','#F07B3F','#FFD460','#C94E4E','#713045','#430D27','#25161B','#453953',
        // //                    '#975A5E','#F3CBA5','#57385C','#A75265','#EC7263','#FEBE7E'];

        // const nice_colors = ["#ffc266", "#d284bd", "#8784db", "#ff7b65", "#caeefc", "#9adbad", "#fff1b2", "#ffe0b2", "#ffbeb2", "#b1afdb"];

        // const small_angle = Math.PI/90;

        // for(const i=0;i<data.length;i++) {
        //     const d = data[i];
        //     const start = angle;
        //     angle += angle_factor * d.y;
        //     const slice: $svg.Arc;

        //     if(options.stroke) {
        //         slice = new $svg.Arc(center, r1, r2, start, angle);
        //         slice.root.style.stroke = options.stroke;
        //     } else {
        //         slice = new $svg.Arc(center, r1, r2, i == 0 ? start - small_angle : start, i != data.length - 1 ? angle + small_angle : angle);
        //     }

        //     if(options.labels) {
        //         let a = (start + angle) / 2;
        //         let point = [center[0] + Math.cos(a) * r3, center[1] + Math.sin(a) * r3];
        //         let text_classes: UIClassesSpec | undefined;

        //         let poly: number[] = [center[0] + Math.cos(a) * r4, center[1] + Math.sin(a) * r4, point[0], point[1]];

        //         if(a < Math.PI/2) {
        //             point[0] = center[0] + radius * 0.9;
        //             poly.push(center[0] + radius * 0.85, point[1])
        //             if(poly[4] < poly[2] + 5)
        //                 poly = [];
        //         } else {
        //             point[0] = center[0] - radius * 0.9;
        //             poly.push(center[0] - radius * 0.85, point[1])
        //             if(poly[4] > poly[2] - 5)
        //                 poly = [];

        //             text_classes = 'm-end';
        //         }

        //         if(poly.length)
        //             root.appendChild($svg.POLYLINE(poly));

        //         root.appendChild($svg.TEXT(d.x, text_classes, point[0], point[1], undefined, '0.35em'));
        //     }

        //     slice.root.style.fill = nice_colors[i % nice_colors.length];
        //     root.appendChild(slice.root);

        //     if(options.values) {
        //         const a = (start + angle) / 2;
        //         const point = [center[0] + Math.cos(a) * r5, center[1] + Math.sin(a) * r5];
        //         const text = typeof options.values == 'function' ? options.values(d) : d.y + '';
        //         root.appendChild($svg.TEXT(text, 'm-center', point[0], point[1], undefined, '0.35em'));
        //     }
        // }

        svg.add(this.root);

        return [x, max_y] as UISize;
    }

    onMouse(_point: UIPoint | undefined, _tooltip: UITooltip) {

    }
}
